//
// CircularProgress
//
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

const CircularProgress = function CircularProgress(props) {
  const {
    className,
    style,
    full = false,
    sizePx,
    withDiv = false,
    white = false,
    pendingPopup = false,
    customSz = false,
  } = props;

  const containerClassName = useMemo(
    () => classNames(
      'relative',
      {
        'w-full h-full': full,
        'w-12 h-12': (!(sizePx || full || customSz)),
      },
      (withDiv) ? null : className,
    ),
    [className, full, sizePx, withDiv, customSz],
  );

  const spinnerClassName = useMemo(
    () => classNames(
      'absolute inset-0 w-full h-full p-1',
      {
        'animate-spin-slow': !white,
        'animate-spin-30deg-steps': white,
      },
    ),
    [white],
  );

  const containerStyle = useMemo(
    () => {
      let ret;
      if (sizePx || style) {
        ret = style || {};

        if (sizePx) {
          ret.height = `${sizePx}px`;
          ret.width = `${sizePx}px`;
        }
      }

      return ret;
    },
    [sizePx, style],
  );

  const spinnerContent = (
    <img
      src={(white)
        ? '/images/svg/color/loadingWhite.svg'
        : '/images/svg/color/loading.svg'}
      className={spinnerClassName}
      alt="loading..."
    />
  );

  if (pendingPopup) {
    return (
      <div
        className="z-2000 backdrop-blur-sm fixed inset-0 flex flex-row items-center justify-center p-12 overflow-hidden bg-pxBgMuted/70"
        tabIndex={-1}
        id="popupBackground"
      >
        <div className={containerClassName} style={containerStyle}>
          {spinnerContent}
        </div>
      </div>
    );
  }

  if (withDiv) {
    const divClassname = classNames(
      'w-full h-full flex items-center justify-center bg-transparent',
      className,
    );

    return (
      <div className={divClassname}>
        <div className={containerClassName} style={containerStyle}>
          {spinnerContent}
        </div>
      </div>
    );
  }

  return (
    <div className={containerClassName} style={containerStyle}>
      {spinnerContent}
    </div>
  );
};

CircularProgress.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  full: PropTypes.bool,
  sizePx: PropTypes.number,
  withDiv: PropTypes.bool,
  white: PropTypes.bool,
  pendingPopup: PropTypes.bool,
  customSz: PropTypes.bool,
};

export default CircularProgress;
